import { api } from '@/config/index.js'
import httpApi from '@/utils/http-api.js'

export default {
  getBusinessAffiliateConfig: () => {
    return httpApi.getDataViaApi({
      url: api.config.contentAffiliate
    })
  }
}
